import { useLocation } from 'react-router';
import { useEffect, useState } from 'react';
import { DesktopSideNav } from './DesktopSideNav';
import { MobileMenu } from './MobileMenu';

export const SideNav = ({ closeMobileMenu, newTitle }) => {
  const [title, setTitle] = useState('overall');

  const location = useLocation();

  useEffect(() => {
    const href = '/admin/dashboard';
    switch (location.pathname) {
      case `${href}/users`:
        setTitle('users');
        break;
      case `${href}/rides`:
        setTitle('rides');
        break;
      case `${href}/feedbacks`:
        setTitle('feedbacks');
        break;
      case `${href}/drivers`:
        setTitle('drivers');
        break;
      case `${href}/settings`:
        setTitle('settings');
        break;
      default:
        setTitle('overall');
    }
  }, [location]);

  useEffect(() => {
    newTitle(title);
    // eslint-disable-next-line
  }, [title]);

  return (
    <div className='sidenav-dash'>
      <div className='modile-sidenav-dash mobile'>
        <MobileMenu closeMobileMenu={closeMobileMenu} title={title} />
      </div>
      <div className='desktop-sidenav-dash desktop'>
        <DesktopSideNav title={title} />
      </div>
    </div>
  );
};
